/* Maison Sabelle house edit: accessible room tabs with a staggered entrance. */
(() => {
  function init(root) {
    if (!root || root.dataset.sbeReady) return;
    root.dataset.sbeReady = '1';
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const panels = tabs.map((t) => root.querySelector(`#${CSS.escape(t.getAttribute('aria-controls'))}`));
    const select = (i, focus) => {
      tabs.forEach((t, k) => {
        const on = k === i;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const p = panels[k];
        if (!p) return;
        p.hidden = !on;
        p.classList.toggle('is-active', on);
        if (on) {
          p.classList.remove('is-entering');
          void p.offsetWidth;
          p.classList.add('is-entering');
        }
      });
      if (focus) tabs[i].focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(i));
      t.addEventListener('keydown', (e) => {
        const n = tabs.length;
        if (e.key === 'ArrowRight') { e.preventDefault(); select((i + 1) % n, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); select((i - 1 + n) % n, true); }
        if (e.key === 'Home') { e.preventDefault(); select(0, true); }
        if (e.key === 'End') { e.preventDefault(); select(n - 1, true); }
      });
    });
    /* Theme editor: selecting a room block shows its tab. */
    root.addEventListener('shopify:block:select', (e) => {
      const i = tabs.findIndex((t) => t.contains(e.target) || t === e.target);
      if (i >= 0) select(i);
    });
  }
  const boot = () => document.querySelectorAll('[data-sbe]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
